import { areIntervalsOverlapping, isAfter } from "date-fns";
import { convertTimeToDate } from "@/utils/convertTimeToDate";
import { Day } from "../types";

/*
    Looks for the first invalid interval
*/
export function validateTimeInIntervals(intervals: Day[]) {
    // simple check if all intervals have correct start and end

    for (let i = 0; i < intervals.length; i++) {
        const start = convertTimeToDate(intervals[i].start);
        const end = convertTimeToDate(intervals[i].end);

        if (isAfter(start, end)) {
            return {
                isValid: false,
                failedIndex: i,
            };
        }
    }

    // sort intervals by start time
    intervals = intervals.toSorted((a, b) => {
        return (
            parseInt(a.start.split(":")[0]) - parseInt(b.start.split(":")[0])
        );
    });

    for (let i = 0; i < intervals.length; i++) {
        const start = convertTimeToDate(intervals[i].start);
        const end = convertTimeToDate(intervals[i].end);

        const hasNext = intervals[i + 1] !== undefined;

        if (hasNext) {
            const nextStart = convertTimeToDate(intervals[i + 1].start);
            const nextEnd = convertTimeToDate(intervals[i + 1].end);

            if (
                areIntervalsOverlapping(
                    { start: start, end: end },
                    { start: nextStart, end: nextEnd },
                )
            ) {
                return {
                    isValid: false,
                    failedIndex: i + 1,
                };
            }
        }
    }

    return {
        isValid: true,
        failedIndex: -1,
    };
}
